module.exports = __webpack_public_path__ + "static/img/AO@3x.7dad4874.jpg";